import React from 'react';
import { TypedMemo } from '../../common/types';
import { SmartLinkStatsViewRendererProps } from './props';
import { LoadingIcon } from '../../common/views/LoadingIcon';
import { SMLStatsPanels } from '../stats/SMLStatsPanels';

/** The window old servers and a screen with no picker read. */
const DEFAULT_DAYS = 14;

const SmartLinkStatsViewRendererComponent: React.FC<SmartLinkStatsViewRendererProps> = ({
  stats,
  isLoading,
  days,
  widgets,
  presaveCount,
  hasCampaign,
  emptyChart,
  isLive,
}) => {
  if (isLoading || !stats) {
    return (
      <div className="d-flex justify-content-center py-4">
        <LoadingIcon />
      </div>
    );
  }

  return (
    <SMLStatsPanels
      stats={stats.stats}
      days={stats.days ?? days ?? DEFAULT_DAYS}
      widgets={widgets}
      presaveCount={presaveCount}
      hasCampaign={hasCampaign}
      emptyChart={emptyChart}
      isLive={isLive}
    />
  );
};

export const SmartLinkStatsViewRenderer = TypedMemo(SmartLinkStatsViewRendererComponent);
